import useSWR from "swr";
import { apiDeviceIdClient } from "services/apiDeviceIdClient";
import { canUseDOM } from "utils/dom";
import { getDeviceId, setDeviceId } from "utils/local-storage";
const fetcher = async () => {
  if (!canUseDOM()) return;
  if (getDeviceId()) return;
  const res = await apiDeviceIdClient.getDeviceId();
  if (res.data) {
    setDeviceId(res.data);
  }
  return;
};
const useDeviceId = () => {
  useSWR("/api/getDeviceId", fetcher, {
    keepPreviousData: true,
    revalidateOnFocus: false,
    dedupingInterval: 30000,
    errorRetryCount: 3,
    revalidateOnMount: false,
    revalidateOnReconnect: false
  });
};
export default useDeviceId;